class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this._debounceMap = {};
    this._pendingQty  = {};
    this.init();
  }

  init() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-icon]') || e.target.closest('.header__icon--cart')) {
        e.preventDefault();
        this.open();
      }
    });

    this.addEventListener('click', (e) => {

      if (e.target.classList.contains('cart-drawer__overlay') || e.target.closest('.cart-drawer__close')) {
        this.close();
      }

      if (e.target.classList.contains('plus')) {
        const input  = e.target.parentElement.querySelector('input');
        const key    = e.target.dataset.key;
        const newQty = parseInt(input.value) + 1;
        this._applyOptimistic(key, newQty, input);
        this._scheduleUpdate(key, newQty);
      }

      if (e.target.classList.contains('minus')) {
        const input  = e.target.parentElement.querySelector('input');
        const key    = e.target.dataset.key;
        const newQty = Math.max(0, parseInt(input.value) - 1);
        this._applyOptimistic(key, newQty, input);
        this._scheduleUpdate(key, newQty);
      }

      if (e.target.closest('.cart-item__remove')) {
      const listItem = e.target.closest('[data-key]');
      const key      = listItem?.dataset.key;
      if (key) {
        if (listItem) {
      listItem.style.position = 'relative';
      listItem.style.pointerEvents = 'none'; 

      const loader = document.createElement('div');
      loader.className = 'cart-item__loader';
      loader.innerHTML = `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="#ccc" stroke-width="2"/>
          <path d="M12 2a10 10 0 0 1 10 10" stroke="#333" stroke-width="2" stroke-linecap="round"/>
        </svg>
      `;
      listItem.appendChild(loader);
        }
        this._scheduleUpdate(key, 0, true);
      }
    }

     
    });

    this.addEventListener('change', (e) => {
      if (e.target.classList.contains('cart-qty-input')) {
        const key    = e.target.dataset.key;
        const newQty = Math.max(0, parseInt(e.target.value) || 0);
        e.target.value = newQty;
        this._scheduleUpdate(key, newQty, newQty === 0);
      }
    });
  }

  _applyOptimistic(key, newQty, input) {
    if (input) input.value = newQty;

    const row = this.querySelector(`[data-key="${key}"]`);
    if (!row) return;

    const unitPrice = parseInt(row.dataset.unitPrice || 0);
    if (unitPrice) {
      const lineEl = row.querySelector('.cart-item__price, .cart-item__final-price');
      if (lineEl) lineEl.textContent = window.formatMoney ? window.formatMoney(unitPrice * newQty) : '';
    }

    row.querySelectorAll('.plus, .minus').forEach(btn => btn.disabled = true);
  }


  _scheduleUpdate(key, qty, forceFullRender = false) {
    this._pendingQty[key] = qty;

    clearTimeout(this._debounceMap[key]);
    this._debounceMap[key] = setTimeout(() => {
      this._sendUpdate(key, this._pendingQty[key], forceFullRender || this._pendingQty[key] === 0);
      delete this._pendingQty[key];
    }, 350);
  }


  _sendUpdate(key, quantity, fullRender) {
    this.classList.add('loading');

    fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: key, quantity })
    })
    .then(() => fetch(`${window.Shopify.routes.root}?sections=cart-drawer`))
    .then(res => res.json())
    .then(data => this.renderContents(data['cart-drawer']))
    .catch(err => console.error('Cart Update Error:', err))
    .finally(() => this.classList.remove('loading'));
  }

  renderContents(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    ['.cart-drawer__inner', '.cart-drawer__subtotal', '.cart-drawer__footer'].forEach(sel => {
      const src = doc.querySelector(sel);
      const tgt = this.querySelector(sel);
      if (src && tgt) tgt.innerHTML = src.innerHTML;
    });

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        initCartRecSwiper();
      });
    });
  }


  _updateCartCount(count) {
    if (count === undefined) return;
    document.querySelectorAll('.cart-count-bubble').forEach(el => el.textContent = count);
  }

  updateCartCount() {
    fetch(`${window.Shopify.routes.root}cart.js`)
      .then(res => res.json())
      .then(cart => this._updateCartCount(cart.item_count));
  }

  open()  { this.classList.add('active');    document.body.style.overflow = 'hidden'; }
  close() { this.classList.remove('active'); document.body.style.overflow = '';       }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}


document.addEventListener('submit', function(e) {
  const form = e.target.closest('form[action$="/cart/add"]');
  if (!form) return;

  e.preventDefault();

  const isRecForm    = form.classList.contains('cart-rec-form');
  const submitButton = form.querySelector('[type="submit"]') || form.querySelector('button');
  const originalHTML = submitButton ? submitButton.innerHTML : '';

  if (submitButton) {
    submitButton.disabled = true;
    if (!isRecForm) submitButton.innerHTML = 'ADDING...';
  }

  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method:  'POST',
    body:    new FormData(form),
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
  .then(res => res.json())
  .then(data => {
    if (data.status === 422) {
      alert(data.description);
    } else {
      refreshCartDrawer();
    }
  })
  .catch(err => console.error('Add to cart error:', err))
  .finally(() => {
    if (submitButton) {
      setTimeout(() => {
        submitButton.disabled  = false;
        submitButton.innerHTML = originalHTML;
      }, 800);
    }
  });
});


function refreshCartDrawer() {
  fetch(`${window.location.pathname}?sections=cart-drawer`)
    .then(res => res.json())
    .then(sections => {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      drawer.renderContents(sections['cart-drawer']);
      setTimeout(() => { if (typeof drawer.open === 'function') drawer.open(); }, 150);
    });
}



// slider code recommendation
let cartRecSwiper = null;

function initCartRecSwiper() {
  if (cartRecSwiper) {
    try { cartRecSwiper.destroy(true, true); } catch (_) {}
    cartRecSwiper = null;
  }

  const swiperEl = document.querySelector('.cart-rec-swiper');
  if (!swiperEl) return;

  const prevBtn = swiperEl.closest('.cart-drawer-recommendations')
    ?.querySelector('[class*="swiper-button-prev--"]');
  const nextBtn = swiperEl.closest('.cart-drawer-recommendations')
    ?.querySelector('[class*="swiper-button-next--"]');

  cartRecSwiper = new Swiper(swiperEl, {   
    slidesPerView: 1,
    spaceBetween: 14,
    loop: false,
    navigation: {
      prevEl: prevBtn || '.swiper-button-prev',
      nextEl: nextBtn || '.swiper-button-next',
    },
  });
}

document.addEventListener('DOMContentLoaded', initCartRecSwiper);

document.addEventListener('cart:updated',  initCartRecSwiper);
document.addEventListener('cart:refresh',  initCartRecSwiper);
document.addEventListener('cart:open',     initCartRecSwiper);

const cartObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (
        node.classList?.contains('cart-rec-swiper') ||
        node.querySelector?.('.cart-rec-swiper')
      ) {
        initCartRecSwiper();
        return;
      }
    }
  }
});

const cartDrawer =
  document.querySelector('cart-drawer') ||
  document.querySelector('#cart-drawer') ||
  document.querySelector('.cart-drawer') ||
  document.body;

cartObserver.observe(cartDrawer, { childList: true, subtree: true });